"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndeterminedIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const UndeterminedIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 100 100" }),
    react_1.default.createElement("path", { d: "M81.8,81.8c17.5-17.5,17.5-46.1,0-63.6C73.3,9.7,62,5,50,5S26.7,9.7,18.2,18.2c-17.5,17.5-17.5,46.1,0,63.6   C26.7,90.3,38,95,50,95S73.3,90.3,81.8,81.8z M25.3,25.3C31.9,18.6,40.7,15,50,15c7.7,0,14.9,2.4,21,7L22,71   C11.7,57.3,12.8,37.7,25.3,25.3z M78,29c10.3,13.7,9.2,33.3-3.3,45.7C68.1,81.4,59.3,85,50,85c-7.7,0-14.9-2.4-21-7L78,29z" })));
exports.UndeterminedIcon = UndeterminedIcon;
exports.default = exports.UndeterminedIcon;
